export default __webpack_public_path__ + "static/media/country.e64dc585.svg";